export const ACCESS_TOKEN = 'access-token';
export const USER_PROFILE = 'user-profile';
export const URL_QUERY_STRING = 'url-query-string';
export const DISCOUNT_CODE = 'discount-code';
export const SESSION_KEY = 'sessionToken';
export const SESSION_KEY_EXPIRY = 'sessionTokenExpiry';

